import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Download, FileText, FileSpreadsheet, FileType } from "lucide-react";
import { exportCSV, exportXLSX, exportPDF } from "@/lib/exportReport";
import { toast } from "sonner";

// Export current filtered+sorted view as CSV/Excel/PDF. Same header info
// (filters + stats) is reproduced in each format so the reader can always
// tell what the report represents.
const ExportMenu = ({ rows, duplicates, filters, sortConfig, stats, boardName, disabled }) => {
  const run = (fn, label) => () => {
    if (!rows || rows.length === 0) {
      toast.warning("Nessun immobile da esportare — la vista corrente è vuota");
      return;
    }
    try {
      fn({ rows, duplicates, filters, sortConfig, stats, boardName });
      toast.success(`Report ${label} generato · ${rows.length} immobili`);
    } catch (e) {
      toast.error(`Errore export ${label}: ${e?.message || e}`);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="rounded-full h-9 border-slate-300 bg-white"
          data-testid="btn-export"
          disabled={disabled}
        >
          <Download className="w-4 h-4 mr-1.5" /> Esporta
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 rounded-xl">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">
          Report vista corrente
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={run(exportPDF, "PDF")} data-testid="export-pdf">
          <FileType className="w-4 h-4 mr-2 text-rose-600" /> PDF (landscape)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={run(exportXLSX, "Excel")} data-testid="export-xlsx">
          <FileSpreadsheet className="w-4 h-4 mr-2 text-emerald-600" /> Excel (.xlsx)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={run(exportCSV, "CSV")} data-testid="export-csv">
          <FileText className="w-4 h-4 mr-2 text-slate-600" /> CSV
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportMenu;
